/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-03 15:42:27
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-03 15:42:54
 */
import styled from 'styled-components';

const StyledCardCart = styled.section`
  del{
    font-weight:normal;
    color: ${(props) => props.theme.lightGray};  
  }
  .thead{
    padding: 10px 0px;
    background: ${(props) => props.theme.lightWhite};
    border-right: none;
    border-left: none;
    font-weight: 700;
    font-size: 13px;
    color: ${(props) => props.theme.secondaryColor};
  }
  .td{
    padding:20px 0px;
    font-size:13px;
  }
  .total{
      font-weight:normal;
      color:${(props) => props.theme.mediumGrey};
      font-size:14px;
      b{
          color:${(props) => props.theme.secondaryColor};
          margin-left:10px;
      }
  }
  .delete-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    color: #dc3545;
  }
`;

const StyledLyraCartItems = styled.div`
  img{
    float:left;
    width:85%;
    height: 120px;
    border-radius:5px;
  }
  .dec{
    float:left;
    padding-top:10px;
    font-size:12px;
    word-wrap: break-word;
    width: 95%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding-left:0px;
      width:100%;
    };
    strong{
    }
  }
  span{
    line-height:22px;
    b{
      font-weight:normal;
      color: ${({ theme: { mediumGrey } }) => mediumGrey};
    }
  }
`;

export { StyledCardCart, StyledLyraCartItems };



// WEBPACK FOOTER //
// client/containers/GiftCardCart/StyledCardCart.js